import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DownloadIndexComponent } from './crud-index/crud-index.component';
import { DownloadCESComponent } from './crud-ces/crud-ces.component';

const routes: Routes = [
  {
    path: '',
    component: DownloadIndexComponent,
  },
  {
    path: 'create',
    component: DownloadCESComponent,
    data: [{ action: 'create' }],
  },
  {
    path: 'view/:id',
    component: DownloadCESComponent,
    data: [{ action: 'view' }],
  },
  {
    path: 'edit/:id',
    component: DownloadCESComponent,
    data: [{ action: 'edit' }],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DownloadsRoutingModule {}
